const Task = () => import('../views/TaskManage/TaskList/index');
const TaskAdd = () => import('../views/TaskManage/TaskList/pages/index');
const TaskCheck = () => import('../views/TaskManage/TaskList/pages/review');
const FeedBack = () => import('../views/TaskManage/Feedback/index.vue');
const Teach = () => import('../views/TaskManage/teach/index.vue');
export default [
  {
    path: '/taskList',
    name: '任务列表',
    component: Task,
    meta: [{ name: '任务列表' }],
  },
  {
    path: '/task/add',
    name: '新增任务',
    component: TaskAdd,
    meta: [{ name: '任务列表', path: '/taskList' }, {name: '新增任务'}],
  },
  {
    path: '/task/edit',
    name: '编辑任务',
    component: TaskAdd,
    meta: [{ name: '任务列表', path: '/taskList' }, {name: '编辑任务'}],
  },
  {
    path: '/task/check',
    name: '审核任务',
    component: TaskCheck,
    meta: [{ name: '任务列表', path: '/taskList' }, {name: '审核任务'}],
  },
  {
    path: '/feedback',
    name: '调研反馈',
    component: FeedBack,
    meta: [{ name: '调研反馈' }],
  },
  {
    path: '/doctorTeach',
    name: '医生讲课',
    component: Teach,
    meta: [{ name: '医生讲课' }],
  },
];
